










































































































































import { Component, Vue, Prop } from 'vue-property-decorator';

import Table from '@/components/molecules/Table/Table.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import FilterTag from '@/componentsV2/molecules/FilterTag/FilterTag.vue';
import TableCard from '@/componentsV2/molecules/TableCard/TableCard.vue';
import EmptyStateTable from '@/componentsV2/molecules/EmptyStateTable/EmptyStateTable.vue';
import CoinsIcon from '@/components/icons/Coins.vue';
import HighestToLowestIcon from '@/components/icons/HighestToLowest.vue';

import { ICoinsPurchased } from '@/models/performance';

import { IPaginationTableHeader } from '@/utils/PaginationUtils';

@Component({
  components: {
    Table,
    TableCell,
    TableHeader,
    TableRow,
    FilterTag,
    TableCard,
    CoinsIcon,
    HighestToLowestIcon,
    EmptyStateTable
  }
})
export default class CoinsPurchasedHistoryList extends Vue {
  @Prop() headers!: Record<string, IPaginationTableHeader>;
  @Prop() coinsPurchased!: ICoinsPurchased[];

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get styleTableCell() {
    return {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: '400',
      padding: '32px',
      color: '#10222D'
    };
  }

  getTwismCoinsValue(item: ICoinsPurchased) {
    return Number(item.businessTransaction.twismCoins || 0).toFixed(2);
  }

  getMobileData(item: ICoinsPurchased) {
    return {
      title: `${item.businessTransaction.externalCustomerName}
              ${item.businessTransaction.externalCustomerLastname}`,
      headerTitle: `${this.getDatePart(item)} • ${this.getTimePart(item)}`,
      list: [
        {
          topic: 'Total coins',
          description: this.amountOfCoinsValue(item),
          iconComponent: 'CoinsIcon',
          iconProps: { width: 17, height: 20 }
        },
        {
          topic: 'Coins bought',
          description: this.getPurchasedAmount(item),
          iconComponent: 'CoinsIcon',
          iconProps: { width: 17, height: 20 }
        },
        {
          topic: 'Reward bonus',
          description: this.getBonusAmount(item),
          className: this.getBonusAmount(item) === '0.00' ? 'zero-value' : ''
        }
      ],
      footer: [
        {
          label: 'Gross Amount',
          value: item.formatted.grossAmount
        },
        {
          label: 'Your revenue:',
          value: item.formatted.netAmount
        }
      ]
    };
  }

  amountOfCoinsValue(item: ICoinsPurchased) {
    const totalAmount =
      item.businessTransaction.grossAmount / 100 +
      (item.businessTransaction.bonusAmount
        ? item.businessTransaction.bonusAmount / 100
        : 0);
    return totalAmount.toFixed(2);
  }

  getPurchasedAmount(item: ICoinsPurchased) {
    const grossAmount = (item.businessTransaction.grossAmount / 100).toFixed(2);
    return grossAmount;
  }

  getBonusAmount(item: ICoinsPurchased) {
    const bonusAmount = item.businessTransaction.bonusAmount
      ? (item.businessTransaction.bonusAmount / 100).toFixed(2)
      : '0.00';
    return bonusAmount;
  }

  getDatePart(item: ICoinsPurchased) {
    const dateParts = (item.formatted as any).externalPaymentDateParts;
    if (dateParts && dateParts.date) {
      return dateParts.date;
    }
    return item.formatted.externalPaymentDate !== '-'
      ? item.formatted.externalPaymentDate.split(' ')[0]
      : '-';
  }

  getTimePart(item: ICoinsPurchased) {
    const dateParts = (item.formatted as any).externalPaymentDateParts;
    if (dateParts && dateParts.time) {
      return dateParts.time;
    }
    return item.formatted.externalPaymentDate !== '-'
      ? item.formatted.externalPaymentDate
          .split(' ')
          .slice(1)
          .join(' ')
      : '';
  }

  detail(rowData: ICoinsPurchased) {
    this.$router.push(
      `/performance/customer-center/purchase/${
        rowData.businessTransaction.externalCustomerId
      }`
    );
  }
}
